const GET_PROFILE_QUESTIONS = 'dofe-bo/award/GET_PROFILE_QUESTIONS'
const GET_PROFILE_QUESTIONS_SUCCESS =
  'dofe-bo/award/GET_PROFILE_QUESTIONS_SUCCESS'
const GET_PROFILE_QUESTIONS_FAIL = 'dofe-bo/award/GET_PROFILE_QUESTIONS_FAIL'

const GET_PARTICIPANT_ANSWERS = 'dofe-bo/award/GET_PARTICIPANT_ANSWERS'
const GET_PARTICIPANT_ANSWERS_SUCCESS =
  'dofe-bo/award/GET_PARTICIPANT_ANSWERS_SUCCESS'
const GET_PARTICIPANT_ANSWERS_FAIL =
  'dofe-bo/award/GET_PARTICIPANT_ANSWERS_FAIL'

const EDIT_PROFILE_QUESTION = 'dofe-bo/award/EDIT_PROFILE_QUESTION'
const EDIT_PROFILE_QUESTION_SUCCESS =
  'dofe-bo/award/EDIT_PROFILE_QUESTION_SUCCESS'
const EDIT_PROFILE_QUESTION_FAIL = 'dofe-bo/award/EDIT_PROFILE_QUESTION_FAIL'

const DELELE_PROFILE_QUESTION = 'dofe-bo/award/DELELE_PROFILE_QUESTION'
const DELELE_PROFILE_QUESTION_SUCCESS =
  'dofe-bo/award/DELELE_PROFILE_QUESTION_SUCCESS'
const DELELE_PROFILE_QUESTION_FAIL =
  'dofe-bo/award/DELELE_PROFILE_QUESTION_FAIL'
const DELELE_PROFILE_QUESTIONS = 'dofe-bo/award/DELELE_PROFILE_QUESTIONS'
const DELELE_PROFILE_QUESTIONS_SUCCESS =
  'dofe-bo/award/DELELE_PROFILE_QUESTIONS_SUCCESS'
const DELELE_PROFILE_QUESTIONS_FAIL =
  'dofe-bo/award/DELELE_PROFILE_QUESTIONS_FAIL'

const initialState = {
  list: [],
  participantAnswers: [],
  detail: {},
  loading: false,
  loaded: false,
  count: null
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PROFILE_QUESTIONS:
      return {
        ...state,
        loading: true
      }
    case GET_PROFILE_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_PROFILE_QUESTIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_PARTICIPANT_ANSWERS:
      return {
        ...state,
        loading: true
      }
    case GET_PARTICIPANT_ANSWERS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        participantAnswers: action.result
      }
    case GET_PARTICIPANT_ANSWERS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getProfileQuestions(organizationId) {
  return {
    types: [
      GET_PROFILE_QUESTIONS,
      GET_PROFILE_QUESTIONS_SUCCESS,
      GET_PROFILE_QUESTIONS_FAIL
    ],
    promise: client =>
      client.get(
        `api/registration/profile-questions?organizationId=${organizationId}`
      )
  }
}

export function getParticipantsAnswers(awardId, { updateParams } = {}) {
  const queryUpdateParams = updateParams ? `?with=${updateParams}` : ''

  return {
    types: [
      GET_PARTICIPANT_ANSWERS,
      GET_PARTICIPANT_ANSWERS_SUCCESS,
      GET_PARTICIPANT_ANSWERS_FAIL
    ],
    promise: client =>
      client.get(
        `api/awards/${awardId}/profile-question-answers${queryUpdateParams}`
      )
  }
}

export function editProfileQuestions(organizationId, data) {
  return {
    types: [
      EDIT_PROFILE_QUESTION,
      EDIT_PROFILE_QUESTION_SUCCESS,
      EDIT_PROFILE_QUESTION_FAIL
    ],
    promise: client =>
      client.post(
        `api/profile-questions/edit?organizationId=${organizationId}`,
        {
          data
        }
      )
  }
}

export function deleteProfileQuestion(organizationId) {
  return {
    types: [
      DELELE_PROFILE_QUESTION,
      DELELE_PROFILE_QUESTION_SUCCESS,
      DELELE_PROFILE_QUESTION_FAIL
    ],
    promise: client =>
      client.del(
        `api/profile-question-sets?organizationId=$1=${organizationId}`
      )
  }
}

export function deleteProfileQuestions(organizationId) {
  return {
    types: [
      DELELE_PROFILE_QUESTIONS,
      DELELE_PROFILE_QUESTIONS_SUCCESS,
      DELELE_PROFILE_QUESTIONS_FAIL
    ],
    promise: client =>
      client.del(
        `api/profile-question-sets?organizationId=$1=${organizationId}`
      )
  }
}
